module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div id=\"thumbnail-pane\" class=\"left-cell\">\r\n</div>\r\n<div  id=\"editor-pane\" class=\"editor-pane\">\r\n    ")
    ; __append( require('form/form.ejs').apply() )
    ; __append(" \r\n</div>\r\n<div class=\"property-pane right-cell\">\r\n        ")
    ; __append( require('designer/right-panel.ejs').apply() )
    ; __append("\r\n</div> ")
  }
  return __output;

}